<script setup lang="ts">
import type { ISchemaOrgProps } from '@/shared/ui/SchemaOrg/model/types/schema';

const props = withDefaults(defineProps<ISchemaOrgProps>(), {
  type: undefined,
  data: () => ({}),
  graph: undefined,
  id: undefined,
});

const schema = computed(() =>
  props.graph
    ? { '@context': 'https://schema.org', '@graph': props.graph }
    : { '@context': 'https://schema.org', '@type': props.type, ...props.data },
);

const key: string = props.id ?? (props.graph ? 'schema-graph' : `schema-${props.type}`);

useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: computed(() => JSON.stringify(schema.value)),
      key,
    },
  ],
});
</script>

<template>
  <slot></slot>
</template>
